/** Cálculo de paginación — extraído para evitar off-by-one repetidos.
 *
 * En la lista de eventos del Radar (§76) `Math.ceil(total/limit)` estaba inline
 * cuatro veces. Un fallo ahí = falta la última página o el botón «siguiente» no
 * se desactiva a tiempo.
 */
export type PageInfo = {
  totalPages: number;
  hasPrev: boolean;
  hasNext: boolean;
};

export function pageInfo(total: number, limit: number, page: number): PageInfo {
  const totalPages = limit > 0 ? Math.ceil(total / limit) : 0;
  return {
    totalPages,
    hasPrev: page > 1,
    hasNext: page < totalPages,
  };
}
